module.exports = "module.exports = __webpack_public_path__ + \"static/media/tableBody.a0f33920.template\";"